<template>
  <div class="not-found-page-container">
    <div class="not-found-page">

      <success-failure-display error message="Seite nicht gefunden"/>

    </div>
  </div>
</template>


<script>
import SuccessFailureDisplay from "@/components/SuccessFailureDisplay";

export default {
  name: "NotFoundPage",
  components: { SuccessFailureDisplay },
  computed: {}
};
</script>

<style>
.not-found-page-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}
.not-found-page {
  max-width: 768px;
  width: 100%;
  font-size: 16px !important;
}
</style>
